module.exports = __webpack_public_path__ + "img/CScout64_ua.991a8239.webp";